import { render, staticRenderFns } from "./GradeDisplay.vue?vue&type=template&id=4be902f8&scoped=true&"
import script from "./GradeDisplay.vue?vue&type=script&lang=ts&"
export * from "./GradeDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./GradeDisplay.vue?vue&type=style&index=0&id=4be902f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be902f8",
  null
  
)

export default component.exports